import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const VolunteerCategories = lazy(() => import('../../../container/organizations-listings/volunteer-categories'));
const VolunteerListings = lazy(() => import('../../../container/organizations-listings/volunteers'));
const View = lazy(() => import('../../../container/organizations-listings/volunteers/View'));
const Add = lazy(() => import('../../../container/organizations-listings/volunteers/Add'));
const Edit = lazy(() => import('../../../container/organizations-listings/volunteers/Edit'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/volunteer-categories`} component={VolunteerCategories} />
      <Route exact path={`${path}/volunteer-listings`} component={VolunteerListings} />
      <Route exact path={`${path}/volunteer-listings/add`} component={Add} />
      <Route exact path={`${path}/volunteer-listings/view/:slug`} component={View} />
      <Route exact path={`${path}/volunteer-listings/edit/:slug`} component={Edit} />
    </Switch>
  );
}

export default PagesRoute;
